import { DateTime, ID, MonthShortNames } from 'types/utility'

export interface PayPeriodTimelineStep {
  completed: boolean
  description: string
  date: DateTime
}

export enum PayPeriodStatus {
  open = 'open',
  needs_approval = 'needs_approval',
  approving = 'approving',
  approved = 'approved',
  needs_payment = 'needs_payment',
  scheduled = 'scheduled',
  marked_as_paid = 'marked_as_paid',
  partially_paid = 'partially_paid',
  paid = 'paid'
}

export type PossibleReportStatus =
  | 'not_submitted'
  | 'needs_approval'
  | 'approved'
  | 'needs_payment'
  | 'paid'
  | 'marked_as_paid'
  | 'rejected'
  | 'scheduled'

export type PayPeriodIssues = 'all' | 'payment_pending' | 'payment_failed'

export interface PayPeriod {
  id: ID
  status: `${PayPeriodStatus}`
  auto_pay: boolean
  paid_at: DateTime | null
  possible_report_statuses: PossibleReportStatus[]
  value_stats: {
    total: number
    approved_total: number
    paid_total: number
    ontime: number
    late: number
    prorated: number
    one_off: number
    failed_payment: number
    needs_payment: number
    needs_approval: number
    rejected: number
    payment_sent: number
    payment_pending: number
    paid: number
  }
  mileage_stats: {
    total: number
  }
  kms_stats: {
    total: number
  }
  report_stats: {
    scheduled?: number
    not_submitted: number
    needs_approval: number
    failed_payment: number
    needs_payment: number
    payment_sent: number
    payment_pending: number
    paid: number
    rejected: number
    late: number
    approved: number
    marked_as_paid: number
  }
  pay_period_timeline: PayPeriodTimelineStep[]
  next_deadline_date?: DateTime
  next_deadline_action?: string
  period_start_date: string
  period_end_date: string
  program_names?: string[]
  kind: 'fixed' | 'variable'
}

export type PayPeriodActions =
  | 'approve'
  | 'pay'
  | 'pay_via_unit'
  | 'reject'
  | 'unpay'
  | 'unapprove'
  | 'mark_as_paid'
  | 'disable_auto_pay'
  | 'enable_auto_pay'

/**  RESPONSES  */
export type ChartReimbursementsResponse = Record<
  MonthShortNames,
  {
    fixed: string | number
    variable: string | number
    one_off: string | number
  }
>

export interface DownloadPayPeriodResponse {
  token_id: ID
}
